// extracted by extract-css-chunks-webpack-plugin
module.exports = {"group_extra_nav":"GroupPageExtraNav__group_extra_nav--1wxSt","close_dialog":"GroupPageExtraNav__close_dialog--3nYZz","buttons":"GroupPageExtraNav__buttons--2A3bN"};